<!--
  Kommerzielle Landingpage „Obst- & Gemüseautomat“ (Bündel obst+gemüse).
  Eigener Winkel: erntefrisch ab Feld/Hof, saisonal, ehrlich nur ungekühlt.
  Referenz: Obstbau Nüberlin (Live-Link) + Hof-Zink-Video. lp-* = shared SCSS.
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🍎</div>
      <span class="lp-eyebrow" i18n="@@obst.hero.eyebrow">Direktvermarktung · erntefrisch · 24/7</span>
      <h1 class="title display" i18n="@@obst.hero.h1">Obst- &amp; Gemüseautomat kaufen</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@obst.hero.lead">
        Verkaufe deine Ernte direkt ab Feld und Hof – rund um die Uhr, bargeldlos und ohne Personal.
        Die <span class="tm">marktbox</span> ist dein wetterfester Obst- und Gemüseautomat für die
        regionale Direktvermarktung.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@obst.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#sortiment" (click)="scrollTo($event, 'sortiment')" i18n="@@obst.hero.ctaAnchor">Was passt rein? ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Obst- und Gemüseautomat für die Direktvermarktung ab Hof" i18n-alt="@@obst.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@obst.hero.badge">🌱 erntefrisch &amp; regional</span>
    </figure>
  </div>
</section>

<!-- ===== Sortiment / Ehrlichkeit zur Kühlung (seiten-eigener Abschnitt) ===== -->
<section id="sortiment" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@obst.sort.h2">Was kommt in den Automaten?</h2>
    <p class="lp-intro reveal" i18n="@@obst.sort.intro">
      Die marktbox verkauft ungekühlt – perfekt für lagerfähige Erzeugnisse. Ehrlich gesagt: kühlpflichtige
      Ware ist (noch) nicht dabei. Dafür läuft alles Lagerfähige zuverlässig rund um die Uhr –
      ob als Apfelautomat, Erdbeerautomat, Spargelautomat oder Kartoffelautomat, du bestimmst das Sortiment.
    </p>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🥔</span>
        <h3 i18n="@@obst.card1.h3">Lagergemüse</h3>
        <p i18n="@@obst.card1.p">Kartoffeln, Zwiebeln, Kürbis, Knoblauch – robust, gefragt und ideal für die Fächer.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🍎</span>
        <h3 i18n="@@obst.card2.h3">Obst &amp; Streuobst</h3>
        <p i18n="@@obst.card2.p">Äpfel, Birnen, Nüsse und Saison-Obst direkt vom Baum in die Box.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🍓</span>
        <h3 i18n="@@obst.card3.h3">Saisonhits</h3>
        <p i18n="@@obst.card3.p">Erdbeeren, Spargel, Kürbiszeit – Sortiment jederzeit an die Ernte anpassen.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🫙</span>
        <h3 i18n="@@obst.card4.h3">Eingemachtes</h3>
        <p i18n="@@obst.card4.p">Marmelade, Saft, Chutney &amp; Co. – veredelte Produkte mit guter Marge.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Video: Hofbesuch (Facade, lädt erst nach Klick) ===== -->
<section class="lp-section">
  <div class="content content--wide lp-media-grid">
    <div class="lp-video__text reveal">
      <span class="lp-eyebrow" i18n="@@obst.video.eyebrow">Aus der Praxis</span>
      <h2 class="lp-h2" i18n="@@obst.video.h2">Zu Besuch beim Obsthof</h2>
      <p class="lp-lead" i18n="@@obst.video.lead">
        Der Obsthof Zink wird in vierter Generation geführt – seit gut 100 Jahren. Vom klassischen
        Gemischtbetrieb hat er sich auf Äpfel spezialisiert und vermarktet erntefrische Ware heute
        direkt über die marktbox.
      </p>
      <blockquote class="lp-quote" i18n="@@obst.video.quote">
        „Ich bin gelernte Obstbaumeisterin und führe den Obsthof gemeinsam mit meinem Mann und meinen Eltern.“
        <cite>— Romana Zeller, Obsthof Zink</cite>
      </blockquote>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@obst.video.cta">Automat konfigurieren</a>
      </div>
    </div>
    <div class="lp-video reveal">
      @if (!videoOpen) {
      <button type="button" class="lp-video__facade" [style.background-image]="'url(' + videoThumb + ')'"
        (click)="openVideo()" aria-label="Video abspielen: Zu Besuch beim Obsthof" i18n-aria-label="@@obst.video.aria">
        <span class="lp-video__play"></span>
      </button>
      } @else {
      <iframe [src]="videoUrl!" title="marktbox – Zu Besuch beim Obsthof" i18n-title="@@obst.video.title"
        allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
</section>

<!-- ===== Live-Link: Obstbau Nüberlin ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@obst.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@obst.live.h2">Sieh, was gerade geerntet im Automaten liegt</h2>
      <p class="lp-lead" i18n="@@obst.live.lead">
        Jede marktbox hat ihren eigenen Live-Link. Deine Kundschaft sieht in Echtzeit, was gerade
        verfügbar ist – hier am Beispiel von Obstbau Nüberlin.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@obst.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@obst.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@obst.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@obst.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Obstbau Nüberlin: Echtzeit-Verfügbarkeit" i18n-title="@@obst.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@obst.live.cap">Live-Beispiel: Obstbau Nüberlin</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@obst.adv.h2">Warum die marktbox als Obstautomat?</h2>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🌦️</span>
        <h3 i18n="@@obst.adv1.h3">Wetterfest &amp; outdoor</h3>
        <p i18n="@@obst.adv1.p">Am Feldrand, am Hoftor oder an der Straße – die marktbox steht draußen und macht jedes Wetter mit.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🕒</span>
        <h3 i18n="@@obst.adv2.h3">24/7 ohne Standdienst</h3>
        <p i18n="@@obst.adv2.p">Kein Wartepersonal an der Hütte: Verkauf läuft auch abends, sonntags und in der Ernte-Hochsaison.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🔒</span>
        <h3 i18n="@@obst.adv3.h3">Abschließbare Klappen</h3>
        <p i18n="@@obst.adv3.p">Diebstahlschutz und geschützte Ware durch einzeln verriegelte Fächer – statt offenem Regal.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">💳</span>
        <h3 i18n="@@obst.adv4.h3">Bargeldlos statt Kasse</h3>
        <p i18n="@@obst.adv4.p">Kartenzahlung am Automaten – kein Bargeld-Schwund, keine Vertrauenskasse mehr nötig.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Zahlen (Segment-Durchschnitt, stellvertretend) ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@obst.stats.h2">Was ein Obstautomat bringt</h2>
    <div class="lp-stats reveal">
      <div class="lp-stat"><span class="lp-stat__n">~2.850 €</span><span class="lp-stat__l" i18n="@@obst.stat1.l">Ø Umsatz pro Automat &amp; Monat in der Saison</span></div>
      <div class="lp-stat"><span class="lp-stat__n">~1.400 €</span><span class="lp-stat__l" i18n="@@obst.stat2.l">Ø Umsatz pro Automat &amp; Monat außerhalb der Saison</span></div>
      <div class="lp-stat"><span class="lp-stat__n">24/7</span><span class="lp-stat__l" i18n="@@obst.stat3.l">Verkauf ohne Personal – auch sonntags</span></div>
    </div>
    <p class="lp-intro reveal" i18n="@@obst.stats.note">
      Besonders stark laufen Erdbeeren, Spargel, Himbeeren und Salat; Äpfel sind der Dauerbrenner.
      Viele Betriebe erweitern Saison für Saison um weitere Automaten. (Durchschnittswerte, stellvertretend fürs Segment.)
    </p>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@obst.price.h2">Obstautomat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@obst.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@obst.price.buyText">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Hofverkauf.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@obst.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@obst.price.rentText">Planbare monatliche Kosten – ideal, um in einer Saison zu starten und zu testen.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@obst.price.cta">Zum Shop – Obstautomat konfigurieren</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@obst.price.fine">
      Mehr Wege der Direktvermarktung:
      <a [routerLink]="['/', links.blog, blogSlug]">Von Verkaufsautomat bis Hofladen</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@obst.mod.h2">Passende Modelle</h2>
    <div class="lp-models">
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="lp-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Obstautomat mit 39 Fächern" i18n-alt="@@obst.mod39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@obst.mod39.text">39 Fächer – für breites Sortiment und höhere Stückzahlen in der Hauptsaison.</p>
          <span class="lp-model__more" i18n="@@obst.mod39.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="lp-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Obstautomat mit 24 Fächern" i18n-alt="@@obst.mod24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@obst.mod24.text">24 Fächer – kompakter Einstieg für den Verkauf ab Feldrand und Hoftor.</p>
          <span class="lp-model__more" i18n="@@obst.mod24.more">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@obst.faq.h2">Häufige Fragen zum Obst- &amp; Gemüseautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@obst.final.h2">Bereit, deine Ernte 24/7 zu verkaufen?</h2>
    <p class="lp-lead" i18n="@@obst.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@obst.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
